import axiosPrivate from "./axiosPrivate";

const getPlanilla = (periodo_planilla, area_id) => {
    return axiosPrivate.get(`rh-practicantes`, {
        params: { periodo_planilla, area_id }
    }).then(response => response.data);
};

const guardarPlanilla = (periodo_planilla, area_id, registro) => {
    return axiosPrivate.post(`rh-practicantes/store`, {
        periodo_planilla,
        area_id,
        registro
    }).then(response => response.data);
};

const validarPlanilla = (periodo_planilla, area_id, accion, usuario_id) => {
    return axiosPrivate.post(`rh-practicantes/validar`, {
        periodo_planilla,
        area_id,
        accion,
        usuario_id
    }).then(response => response.data);
};

const actualizarPago = (data) => {
    return axiosPrivate.post(`rh-practicantes/actualizar-pago`, data)
        .then(response => response.data);
};

const RhPracticantesService = {
    getPlanilla,
    guardarPlanilla,
    validarPlanilla,
    actualizarPago
};

export default RhPracticantesService;
